import { useDisclosure } from '@chakra-ui/react';
import { ConfirmPopup } from 'components/popups/confirmPopup';
import { TweetContext } from 'context/tweetContext';
import { getToken } from 'firebaseClient';
import { useSession } from 'next-auth/react';
import React, { useState } from 'react';
import toast from 'react-hot-toast';

export const useRemoveClient = (creator) => {
  const tweetContext: any = React.useContext(TweetContext);
  const { data: session } = useSession() ?? {};
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const RemovePopup = () => (
    <ConfirmPopup
      isOpen={isOpen}
      onClose={onClose}
      title="Remove account from list"
      allowClickBackground={true}
      body={'Are you sure you want to remove this creator from your list?'}
      callback={async () => {
        if (!session?.user?.uid) {
          toast.error('You need to be logged in to do that');
          return;
        }

        setIsLoading(true);

        let dataToSend = {
          idAccount: creator?.idAccount,
          idUser: creator?.idUser,
          tokenUserId: session?.user?.uid,
          token: await getToken(session, 'addLinkAccount'),
        };
        let response = await fetch('/api/ghostwriting/removeLinkAccount', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataToSend),
        });
        let json = await response.json();
        // console.log('json:', json)
        if (json?.success) {
          toast.success('Creator remove from client list');
          session.user.data.linkAccounts = json?.linkAccounts;
        } else toast.error(json.error ?? 'An error happened');

        setIsLoading(false);
        tweetContext.refresher({});
      }}
    />
  );

  return { onOpen, isLoading, RemovePopup };
};
